module.exports = __webpack_public_path__ + "public/img/en-w.171bc164.svg";